// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ARTICLES_TITLE = "\u010cl\u00e1nky";
export const CURRENCY_ISO = "CZK";
export const FORUM = "Diskuze";
export const SEO_TITLE_STROLLERS = "Ko\u010d\u00e1rkopedie - Vyhled\u00e1va\u010d a porovn\u00e1va\u010d ko\u010d\u00e1rk\u016f";
export const WIKI_REVIEWS = "Centrum recenz\u00ed";
